import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ConfigProvider } from './context/ConfigContext';
import PrivateRoute from './components/PrivateRoute';
import RoleRoute from './components/RoleRoute';

// Páginas
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import VentasPage from './pages/VentasPage';
import ProductosPage from './pages/ProductosPage';
import CategoriasPage from './pages/CategoriasPage';
import ComprasPage from './pages/ComprasPage';
import ClientesPage from './pages/ClientesPage';
import ProveedoresPage from './pages/ProveedoresPage';
import CajaPage from './pages/CajaPage';
import ReportesPage from './pages/ReportesPage';
import ConfiguracionPage from './pages/ConfiguracionPage';
import CotizacionesPage from './pages/CotizacionesPage';
import CreditoPage from './pages/CreditoPage';
import BackupPage from './pages/BackupPage';
import UsuariosPage from './pages/UsuariosPage';
import RolesPage from './pages/RolesPage';
import PermisosPage from './pages/PermisosPage';

import NuevaCompraPage from './pages/NuevaCompraPage';
import NuevaCotizacionPage from './pages/NuevaCotizacionPage';
import MayoristaPage from './pages/MayoristaPage';

function App() {
  return (
    <AuthProvider>
      <ConfigProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            
            <Route path="/" element={<PrivateRoute />}>
              <Route index element={<DashboardPage />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="ventas" element={<VentasPage />} />
              <Route path="mayorista" element={<MayoristaPage />} />
              <Route path="productos" element={<ProductosPage />} />
              <Route path="categorias" element={<CategoriasPage />} />
              <Route path="compras" element={<ComprasPage />} />
              <Route path="compras/nueva" element={<NuevaCompraPage />} />
              <Route path="clientes" element={<ClientesPage />} />
              <Route path="proveedores" element={<ProveedoresPage />} />
              <Route path="caja" element={<CajaPage />} />
              <Route path="cotizaciones" element={<CotizacionesPage />} />
              <Route path="cotizaciones/nueva" element={<NuevaCotizacionPage />} />
              <Route path="credito" element={<CreditoPage />} />
              <Route path="reportes" element={<ReportesPage />} />

              <Route element={<RoleRoute allowedRoles={['admin']} />}>
                <Route path="backup" element={<BackupPage />} />
                <Route path="configuracion" element={<ConfiguracionPage />} />
                <Route path="roles" element={<RolesPage />} />
                <Route path="permisos" element={<PermisosPage />} />
              </Route>

              <Route element={<RoleRoute allowedRoles={['admin', 'gerente']} />}>
                <Route path="usuarios" element={<UsuariosPage />} />
              </Route>
            </Route>
            
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </ConfigProvider>
    </AuthProvider>
  );
}

export default App;
